import { render, staticRenderFns } from "./approveList.vue?vue&type=template&id=74be4876&scoped=true&"
import script from "./approveList.vue?vue&type=script&lang=js&"
export * from "./approveList.vue?vue&type=script&lang=js&"
import style0 from "./approveList.vue?vue&type=style&index=0&id=74be4876&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74be4876",
  null
  
)

export default component.exports